type Props = {
  currentListCount: number
  hasSuggestion:    boolean
}

function getSubline({ currentListCount, hasSuggestion }: Props): string {
  if (currentListCount > 0)
    return `${currentListCount} ${currentListCount === 1 ? 'item' : 'items'} ready for your next run.`
  if (hasSuggestion)       return "A list's queued up based on what you're out of."
  return "Nothing to shop for yet. You're fully stocked."
}

export function ShopMasthead(props: Props) {
  return (
    <header className="mb-5 border-b border-border-sand pb-4">
      <div className="text-[10px] uppercase tracking-[0.18em] text-ink-muted font-medium">
        Shopping
      </div>
      <h1 className="font-serif text-[28px] font-normal tracking-[-0.015em] text-ink leading-[1.05]">
        <em className="italic">Shop</em>
      </h1>
      <p className="font-serif text-[13px] italic text-ink-muted mt-1 leading-[1.4]">
        {getSubline(props)}
      </p>
    </header>
  )
}
